import { useState } from 'react'
import { useTrainerAttendanceList } from '../../assets/api/useAdminApi';
import useAuthStore from '../../store/useAuthStore';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import { Grid2, Typography } from '@mui/material';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { Field } from 'formik';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { DateFormField } from '../../shared/components/formfields/DataFormField';

const TrainerAttendanceLists = () => {
    const [filters, setFilters] = useState({})
    const { user } = useAuthStore()
    const { data: attendanceList, isLoading: isAttendaceLoading } = useTrainerAttendanceList({ trainer_id: user?.id, ...filters })
    console.log(attendanceList,'------------ attendance list --------');
    
    const attendanceRow = attendanceList?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) || [];
    const uniqueCourses = Array.from(
        new Map(attendanceList?.map(item => [item?.course_id, item])).values()
    ).map(item => ({ value: item?.course_title, label: item?.course_title, id: item?.course_id }));

    const uniqueApartment = Array.from(
        new Map(attendanceList?.map(item => [item?.apartment_id, item])).values()
    ).map(item => ({ value: item?.apartment_name, label: item?.apartment_name, id: item?.apartment_id, }));
    const uniqueBatch = Array.from(
        new Map(attendanceList?.map(item => [item?.batch_id, item])).values()
    ).map(item => ({ value: item?.batch_name, label: item?.batch_name, id: item?.batch_id, }));

    const attendanceColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "Trainer Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "course_title",
            headerName: "Title",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "batch_name",
            headerName: "Batch Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "created_date",
            headerName: "Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },

        {
            field: "attendance_status",
            headerName: "Attendance Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" color={params.value === 1 ? "success.main" : "error.main"
            } > {params.value === 1 ? "Present" : "Absent"} </Typography >,
        },

    ];


    return (
        <>
             <TableFilterTemplate
                title="Attendance List"
                columns={attendanceColumn}
                rowsData={attendanceRow || []}
                isLoading={isAttendaceLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({values}) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="country_id"
                                component={IdAutoCompleteField}
                                options={uniqueCourses}
                                label="Course"

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="apartment_id"
                                component={IdAutoCompleteField}
                                options={uniqueApartment}
                                label="Apartment"

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="batch_id"
                                component={IdAutoCompleteField}
                                options={uniqueBatch}
                                label="Batch"

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="start_date"
                                component={DateFormField}
                                label="Start Date"
                                isRequired={true}
                                maxDate={values.end_date || undefined}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="end_date"
                                component={DateFormField}
                                label="End Date"
                                isRequired={true}
                                minDate={values.start_date || undefined}
                            />
                        </Grid2>

                    </>
                )}
            />
        </>
    )
}

export default TrainerAttendanceLists